class IngredientsCarousel extends SliderComponent {
  constructor() {
    super();

    this.infoLists = this.querySelectorAll('.info-body__block');
    this.infoTitle = this.querySelector('.list-item__title');

    this.lastSlideOffset = 0;

    this.addEventListener('slideChanged', this.onSlideChanged.bind(this));
  }

  onSlideChanged(event) {
    if (!event.detail.currentElement) return;

    this.sliderItems.forEach((slide) => slide.classList.remove('active-slide'));
    event.detail.currentElement.classList.add('active-slide');

    this.updateContent(event.detail.currentElement, event.detail.currentPage);
  }

  updateContent(currentSlide, currentIndex) {
    const slideTitle = currentSlide.dataset.title;
    const activeInfo = Array.from(this.infoLists).find((slide) => slide.dataset.infoIndex === String(currentIndex));

    this.infoTitle.textContent = slideTitle;

    this.infoLists.forEach((info) => {
      info.style.display = 'none';
    });

    activeInfo.style.display = 'flex';
  }

  isSlideVisible(element, offset = 0) {
    this.lastSlideOffset = parseInt(
      window.getComputedStyle(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]).marginRight
    );

    if (this.lastSlideOffset > 0) {
      offset = this.lastSlideOffset;
    }

    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }
}

customElements.define('ingredients-carousel', IngredientsCarousel);
